export const redirect = async (redirectPath: string, newTab: boolean = false): Promise<void> => {
  // Gatsby build doesn't have a window, need to check here
  if (typeof window !== 'undefined') {
    if (newTab) {
      window.open(redirectPath, '_blank')
    } else {
      window.location.href = redirectPath
    }
  }
}
